import React, { useState } from 'react';
import HamburgerMenu from '../global/menu';
import '../global/styles.css';

function PhoneDirectory({ userInfo, isAdmin, onLogout, onNavigate }) {
  const [searchTerm, setSearchTerm] = useState('');

  const contacts = [
    {
      name: "Ascension St Johns",
      address: "205 Trinity Way, St. Augustine, FL 32084",
      phone: "+19046911000",
      mapUrl: "https://www.google.com/maps/search/?api=1&query=205+Trinity+Way,+St.+Augustine,+FL+32084"
    },
    {
      name: "Baptist Beaches",
      address: "1350 13th Ave S, Jacksonville Beach, FL 32250",
      phone: "+19046272999",
      mapUrl: "https://www.google.com/maps/search/?api=1&query=1350+13th+Ave+S,+Jacksonville+Beach,+FL+32250"
    },
    {
      name: "Baptist North",
      address: "11250 Baptist Health Dr, Jacksonville, FL 32218",
      phone: "+19042026900",
      mapUrl: "https://www.google.com/maps/search/?api=1&query=11250+Baptist+Health+Dr,+Jacksonville,+FL+32218"
    },
    {
      name: "Baptist South",
      address: "14550 Old St Augustine Rd, Jacksonville, FL 32258",
      phone: "+19048216100",
      mapUrl: "https://www.google.com/maps/search/?api=1&query=14550+Old+St+Augustine+Rd,+Jacksonville,+FL+32258"
    },
    {
      name: "Baptist/Wolfson's Oakleaf",
      address: "9868 Family Place, Jacksonville, FL 32222",
      phone: "+19045161600",
      mapUrl: "https://www.google.com/maps/search/?api=1&query=9868+Family+Place,+Jacksonville,+FL+32222"
    },
    {
      name: "Baptist/Wolfson's Town Center",
      address: "4085 Town Center Pkwy, Jacksonville, FL 32246",
      phone: "+19042026800",
      mapUrl: "https://www.google.com/maps/search/?api=1&query=4085+Town+Center+Pkwy,+Jacksonville,+FL+32246"
    },
    {
      name: "BMC Clay",
      address: "1771 Blanding Blvd, Middleburg, FL 32068",
      phone: "+19045161000",
      mapUrl: "https://www.google.com/maps/search/?api=1&query=1771+Blanding+Blvd,+Middleburg,+FL+32068"
    },
    {
      name: "BMC St Augustine",
      address: "105 Whitehall Dr, St Augustine, FL 32086",
      phone: "+19042022000",
      mapUrl: "https://www.google.com/maps/search/?api=1&query=105+Whitehall+Dr,+St+Augustine,+FL+32086"
    },
    {
      name: "BMC/Wolfson's Jacksonville",
      address: "800 Prudential Dr, Jacksonville, FL 32207",
      phone: "+19042022048",
      mapUrl: "https://www.google.com/maps/search/?api=1&query=800+Prudential+Dr,+Jacksonville,+FL+32207"
    },
    {
      name: "Brandon Schoborg",
      phone: "+18596092425"
    },
    {
      name: "Dan Talbert",
      phone: "+19045356772"
    },
    {
      name: "Dr. Kerri Bachista",
      phone: "+19046523070"
    },
    {
      name: "Dr. Leslie Simon",
      phone: "+19043838450"
    },
    {
      name: "HCA Florida Atlantic",
      address: "11850 Atlantic Blvd, Jacksonville, FL 32225",
      phone: "+19049985000",
      mapUrl: "https://www.google.com/maps/search/?api=1&query=11850+Atlantic+Blvd,+Jacksonville,+FL+32225"
    },
    {
      name: "HCA Mandarin",
      address: "10910 San Jose Blvd, Jacksonville, FL 32223",
      phone: "+19044078500",
      mapUrl: "https://www.google.com/maps/search/?api=1&query=10910+San+Jose+Blvd,+Jacksonville,+FL+32223"
    },
    {
      name: "HCA Memorial",
      address: "3625 University Blvd S, Jacksonville, FL 32216",
      phone: "+19043996156",
      mapUrl: "https://www.google.com/maps/search/?api=1&query=3625+University+Blvd+S,+Jacksonville,+FL+32216"
    },
    {
      name: "HCA OPMC",
      address: "2001 Kingsley Ave, Orange Park, FL 32073",
      phone: "+19046393971",
      mapUrl: "https://www.google.com/maps/search/?api=1&query=2001+Kingsley+Ave,+Orange+Park,+FL+32073"
    },
    {
      name: "HCA Parkwest",
      address: "6477 103rd St, Jacksonville, FL 32210",
      phone: "+19047723300",
      mapUrl: "https://www.google.com/maps/search/?api=1&query=6477+103rd+St,+Jacksonville,+FL+32210"
    },
    {
      name: "MCJMT TC",
      phone: "+19049561820"
    },
    {
      name: "Mayo ATC",
      phone: "+19049531111"
    },
    {
      name: "Mayo ER",
      address: "4500 San Pablo Road, Jacksonville, FL 32224",
      phone: "+19049560033",
      mapUrl: "https://www.google.com/maps/search/?api=1&query=4500+San+Pablo+Road,+Jacksonville,+FL+32224"
    },
    {
      name: "NAS Jacksonville",
      address: "2080 Child St, Jacksonville, FL 32214",
      phone: "+19045427340",
      mapUrl: "https://www.google.com/maps/search/?api=1&query=2080+Child+St,+Jacksonville,+FL+32214"
    },
    {
      name: "Steve Magargle",
      phone: "+19045997939"
    },
    {
      name: "St Vincent's Clay",
      address: "1670 St Vincent's Way, Middleburg, FL 32068",
      phone: "+19046021000",
      mapUrl: "https://www.google.com/maps/search/?api=1&query=1670+St+Vincent's+Way,+Middleburg,+FL+32068"
    },
    {
      name: "St Vincent's South",
      address: "4201 Belfort Rd, Jacksonville, FL 32216",
      phone: "+19042963784",
      mapUrl: "https://www.google.com/maps/search/?api=1&query=4201+Belfort+Rd,+Jacksonville,+FL+32216"
    },
    {
      name: "St Vincents",
      address: "1 Shircliff Way, Jacksonville, FL 32204",
      phone: "+19043087300",
      mapUrl: "https://www.google.com/maps/search/?api=1&query=1+Shircliff+Way,+Jacksonville,+FL+32204"
    },
    {
      name: "UF Flagler",
      address: "400 Health Park Blvd, St. Augustine, FL 32086",
      phone: "+19048194300",
      mapUrl: "https://www.google.com/maps/search/?api=1&query=400+Health+Park+Blvd,+St.+Augustine,+FL+32086"
    },
    {
      name: "UF Health",
      address: "655 W 8th St, Jacksonville, FL 32209",
      phone: "+19042446202",
      mapUrl: "https://www.google.com/maps/search/?api=1&query=655+W+8th+St,+Jacksonville,+FL+32209"
    },
    {
      name: "UF Health North",
      address: "15255 Max Leggett Pkwy, Jacksonville, FL 32218",
      phone: "+19043831000",
      mapUrl: "https://www.google.com/maps/search/?api=1&query=15255+Max+Leggett+Pkwy,+Jacksonville,+FL+32218"
    }
  ];

  const filteredContacts = contacts.filter(contact => {
    const searchLower = searchTerm.toLowerCase();
    return (
      contact.name.toLowerCase().includes(searchLower) ||
      (contact.address && contact.address.toLowerCase().includes(searchLower)) ||
      contact.phone.includes(searchTerm)
    );
  });

  // Phone Icon SVG
  const PhoneIcon = () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>
    </svg>
  );

  // Location Pin Icon SVG
  const LocationIcon = () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
      <circle cx="12" cy="10" r="3"></circle>
    </svg>
  );

  return (
    <div className="container-center" style={{ paddingBottom: '80px' }}>
      {/* Hamburger Menu */}
      <HamburgerMenu
        isAdmin={isAdmin}
        onLogout={onLogout}
        onNavigate={onNavigate}
      />

      <div className="card card-center" style={{
        maxWidth: '800px',
        width: '100%',
        padding: '40px'
      }}>
        {/* Header */}
        <div style={{
          textAlign: 'center',
          marginBottom: '30px',
          borderBottom: '2px solid #0E3293',
          paddingBottom: '20px'
        }}>
          <h2 style={{
            fontSize: '32px',
            fontWeight: 'bold',
            color: '#0E3293',
            margin: '0 0 15px 0',
            letterSpacing: '-0.5px'
          }}>
            Phone & Address Directory
          </h2>
          <p style={{
            fontSize: '14px',
            color: '#777',
            margin: '0',
            lineHeight: '1.6',
            fontStyle: 'italic'
          }}>
            Tap and hold or click and drag to copy information
          </p>
        </div>

        {/* Search Box */}
        <div style={{ marginBottom: '25px' }}>
          <input
            type="text"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            placeholder="Search for a name or phone number..."
            style={{
              width: '100%',
              padding: '14px 18px',
              border: '2px solid #ddd',
              borderRadius: '8px',
              fontSize: '16px',
              outline: 'none',
              transition: 'border-color 0.2s ease'
            }}
            onFocus={(e) => e.target.style.borderColor = '#0E3293'}
            onBlur={(e) => e.target.style.borderColor = '#ddd'}
          />
        </div>

        {/* Contact List */}
        <div style={{
          maxHeight: '60vh',
          overflowY: 'auto',
          padding: '5px'
        }}>
          {filteredContacts.length > 0 ? (
            filteredContacts.map((contact, index) => (
              <div
                key={index}
                style={{
                  background: '#f8f9fa',
                  padding: '18px 20px',
                  borderRadius: '10px',
                  marginBottom: '15px',
                  boxShadow: '0 2px 6px rgba(0, 0, 0, 0.08)',
                  border: '1px solid #e0e0e0'
                }}
              >
                <div style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'flex-start',
                  gap: '15px'
                }}>
                  {/* Contact Info - Selectable Text */}
                  <div style={{ flex: 1, minWidth: '200px', userSelect: 'text' }}>
                    <div style={{
                      fontSize: '18px',
                      fontWeight: 'bold',
                      color: '#333',
                      marginBottom: '6px'
                    }}>
                      {contact.name}
                    </div>
                    {contact.address && (
                      <div style={{
                        fontSize: '14px',
                        color: '#666',
                        marginBottom: '6px',
                        lineHeight: '1.4'
                      }}>
                        {contact.address}
                      </div>
                    )}
                    <div style={{
                      fontSize: '14px',
                      color: '#0E3293',
                      fontWeight: '500'
                    }}>
                      {contact.phone.replace('+1', '').replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3')}
                    </div>
                  </div>

                  {/* Action Buttons */}
                  <div style={{
                    display: 'flex',
                    gap: '10px',
                    flexShrink: 0
                  }}>
                    {/* Phone Button */}
                    <a
                      href={`tel:${contact.phone}`}
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        width: '44px',
                        height: '44px',
                        background: '#28a745',
                        border: 'none',
                        borderRadius: '8px',
                        color: 'white',
                        cursor: 'pointer',
                        transition: 'all 0.2s ease',
                        textDecoration: 'none',
                        boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.background = '#218838';
                        e.currentTarget.style.transform = 'translateY(-2px)';
                        e.currentTarget.style.boxShadow = '0 4px 8px rgba(0,0,0,0.15)';
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.background = '#28a745';
                        e.currentTarget.style.transform = 'translateY(0)';
                        e.currentTarget.style.boxShadow = '0 2px 4px rgba(0,0,0,0.1)';
                      }}
                      title="Call"
                    >
                      <PhoneIcon />
                    </a>

                    {/* Location Button - Only for facilities with addresses */}
                    {contact.mapUrl && (
                      <a
                        href={contact.mapUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          width: '44px',
                          height: '44px',
                          background: '#0E3293',
                          border: 'none',
                          borderRadius: '8px',
                          color: 'white',
                          cursor: 'pointer',
                          transition: 'all 0.2s ease',
                          textDecoration: 'none',
                          boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.background = '#062154';
                          e.currentTarget.style.transform = 'translateY(-2px)';
                          e.currentTarget.style.boxShadow = '0 4px 8px rgba(0,0,0,0.15)';
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.background = '#0E3293';
                          e.currentTarget.style.transform = 'translateY(0)';
                          e.currentTarget.style.boxShadow = '0 2px 4px rgba(0,0,0,0.1)';
                        }}
                        title="View on Maps"
                      >
                        <LocationIcon />
                      </a>
                    )}
                  </div>
                </div>
              </div>
            ))
          ) : (
            <div style={{
              textAlign: 'center',
              padding: '40px',
              color: '#999',
              fontSize: '16px'
            }}>
              No contacts found matching "{searchTerm}"
            </div>
          )}
        </div>
      </div>

      {/* Fixed Footer */}
      <footer style={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        width: '100%',
        background: '#ffffff',
        textAlign: 'center',
        padding: '15px 10px',
        boxShadow: '0 -2px 10px rgba(0,0,0,0.08)',
        zIndex: 9999,
        borderTop: '1px solid #e0e0e0'
      }}>
        <div style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: '10px',
          flexWrap: 'wrap'
        }}>
          <img
            src="https://us.api.fliplet.com/v1/media/files/5174683/contents/blob"
            alt="NarcoticTrack Logo"
            style={{
              height: '32px',
              verticalAlign: 'middle'
            }}
          />
          <span style={{
            fontSize: '14px',
            color: '#666',
            fontWeight: '400'
          }}>
            © 2025 NarcoticTrack Inventory System, LLC
          </span>
        </div>
      </footer>
    </div>
  );
}

export default PhoneDirectory;
